import { useMutation } from '@apollo/client';
import CREATE_PREREQUISIT_SET from '../mutations/CREATE_PREREQUISIT_SET';

export default function useCreatePrerequisiteMutation() {
    return useMutation( CREATE_PREREQUISIT_SET );
}
